
<div class="wrapper mainscrollsection">
    <div class="sidebar" data-color="white" data-background-color="azure" data-image="./assets/img/sidebar-1.jpg">
        <app-sidebar-cmp></app-sidebar-cmp>
        <div *ngIf="showBackImage" class="sidebar-background" style="background-image: url(assets/img/sidebar-1.jpg)"></div>
    </div>
    <div class="main-panel">
        <mat-progress-bar *ngIf="AppService.ShowProgressBar" style="margin-bottom: 1em;" mode="query"></mat-progress-bar>
        <app-navbar-cmp></app-navbar-cmp>
        <router-outlet></router-outlet>
        <div *ngIf="!isMap()">
            <app-footer-cmp style="width: 100%; position: fixed; bottom: 0px; background: #eeeeee;"></app-footer-cmp>
        </div>
    </div>
    <!-- <app-fixedplugin></app-fixedplugin> -->
</div>
